import { render, staticRenderFns } from "./Memoriams.vue?vue&type=template&id=3c4c4412&"
import script from "./Memoriams.vue?vue&type=script&lang=js&"
export * from "./Memoriams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports